// extracted by mini-css-extract-plugin
export default {"time":"app_time__jWt-o"};